export const SET_TOKEN = 'Auth//SET_TOKEN'
export const SET_USER = 'Auth//SET_USER'
export const MARK_NOTIFICATION_AS_READ = 'Auth//MARK_NOTIFICATION_AS_READ'
export const SET_REDIRECT = 'Auth//SET_REDIRECT'
